import React, { useContext, useState, useEffect } from "react";
import { UbicationIndexContext } from "../../../../contexts/general/UbicationIndexContext";
import {
  SecurityContext,
  STATUS_NOT_LOADED,
  STATUS_ACTIVE,
  STATUS_INACTIVE,
  STATUS_LOADING,
} from "../../../../contexts/security/SecurityContext";
import { Animated } from "react-animated-css";
import "./modalCreate.css";
import { Form, Field } from "react-final-form";
import Switch from "react-switch";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFolder, faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { useLocation, useHistory } from "react-router-dom";
import Select, { components } from "react-select";
import { MAX_MB, STATIONS_TYPE } from "../../../../js/constant";
import { AlertContext } from "../../../../contexts/alerts/AlertContext";
import IconExtension from "../../complements/IconExtension";
import Swal from "sweetalert2";
const initialState = {
  position: {},
  initialValues: {},
};
const ModalCreate = () => {
  let history = useHistory();
  const [{ user }, { shortText, stylesSelect }] = useContext(SecurityContext);
  const [
    { modalUbication, pictures, ubications, metaRowUbication, status },
    {
      setmodalUbication,
      createUbication,
      addDocumentsToUbication,
      updateUbication,
      setpictures,
      setubications,
      checkDeleteDocument,
      setmetaRowUbication,
      removePicture,
    },
  ] = useContext(UbicationIndexContext);
  const [{}, { alertSuccess, alertInfo, alertWarning }] =
    useContext(AlertContext);
  const [initialValues, setinitialValues] = useState(
    initialState.initialValues
  );

  useEffect(() => {
    if (modalUbication.ubication) {
      setinitialValues({
        ...initialValues,
        name: modalUbication.ubication.name,
        code: modalUbication.ubication.code,
        ip_machine: modalUbication.ubication.ip_machine,
        type: STATIONS_TYPE.filter(
          (t) => t.id == modalUbication.ubication.type
        )[0],
        status_id:
          modalUbication.ubication.status_id === STATUS_ACTIVE ? true : false,
      });
    } else {
      setinitialValues({
        ...initialValues,
        status_id: true,
      });
    }
  }, [modalUbication.turn]);
  const onSubmit = async (values) => {
    values.status_id =
      values.status_id === STATUS_ACTIVE || values.status_id === true
        ? STATUS_ACTIVE
        : STATUS_INACTIVE;
    if (modalUbication.ubication) {
      if (status.update === STATUS_LOADING) {
        alertWarning("Aun se esta ejecutando esta operación");
        return false;
      }
      alertInfo("Editando estación...", false);
      values.ip_machine = values.ip_machine ? values.ip_machine : null;
      let data = await updateUbication(values, modalUbication.ubication.id);

      if (data) {
        await addDocumentsToUbication(data.id);
        setubications({ ...ubications, status: STATUS_NOT_LOADED });
        setmetaRowUbication({
          ...metaRowUbication,
          orderBy: metaRowUbication.orderBy,
        });
        setmodalUbication({ ...modalUbication, open: false, ubication: null });
        setpictures([]);
        alertSuccess("Estación editada satisfactoriamente");
      }
    } else {
      if (status.create === STATUS_LOADING) {
        alertWarning("Aun se esta ejecutando esta operación");
        return false;
      }
      alertInfo("Creando la estación...", false);
      createUbication(values);
    }
  };

  const renderToggleInput = (field) => (
    <Switch
      onColor={user.cl1.color}
      onHandleColor={user.cl1.color}
      handleDiameter={25}
      className="react-switch"
      boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
      activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
      height={20}
      width={48}
      onChange={field.input.onChange}
      checked={
        field.input.value == STATUS_ACTIVE || field.input.value === true
          ? true
          : false
      }
    />
  );
  const uploadImage = () => (e) => {
    let file = e.target.files[0];
    if (file) {
      let mb = Math.round(file.size / 1024 / 1024);
      if (mb > MAX_MB) {
        Swal.fire({
          title: "Has superado el máximo de capacidad",
          text: "¡máximo " + MAX_MB + " mb!",
          icon: "warning",
          showCancelButton: false,
          confirmButtonColor: user.cl1.color,
          cancelButtonColor: user.cl2.color,
          confirmButtonText: "Entendido",
        });
        return false;
      } else {
        setpictures([...pictures, file]);
      }
    }
  };
  const required = (value) => (value ? undefined : "Campo requerido");
  return (
    <div className="back-document">
      <Animated animationIn="fadeIn" animationOut="fadeInDown" isVisible={true}>
        <div className="modal-standard-app modal-create-station-plant">
          <div style={user.cl1} className="flex justify-betwen">
            <div className="font-title">
              {modalUbication.ubication ? "Editar estación" : "Crear estación"}
            </div>
            <div>
              <strong
                onClick={() => {
                  setmodalUbication({
                    ...modalUbication,
                    open: false,
                    ubication: null,
                  });
                  setpictures([]);
                }}
                className="cursor-pointer btn-close-modal"
              >
                X
              </strong>
            </div>
          </div>
          <div className="flex container-modal-create-line">
            <Form
              initialValues={initialValues}
              onSubmit={onSubmit}
              render={({ handleSubmit }) => (
                <form
                  className="w-100"
                  style={user.cl1}
                  onSubmit={handleSubmit}
                >
                  <div className="flex-column">
                    <div className="flex justify-betwen">
                      {/*  <Field name="status_id">
                        {({ input, meta }) => (
                          <div className="form-group-app">
                            <label
                              className="font-description"
                              style={user.cl2}
                            >
                              {input.value ? "Desactivar" : "Activar"}
                            </label>
                            <Field
                              name="status_id"
                              component={renderToggleInput}
                            />
                            {meta.touched && meta.error && (
                              <span>{meta.error}</span>
                            )}
                          </div>
                        )}
                      </Field> */}
                      <Field name="name" validate={required}>
                        {({ input, meta }) => (
                          <div className="form-group-app w-100">
                            <label style={user.cl2}>Nombre de la estación</label>
                            <input
                              className="input-nombre-create-station-plant "
                              type="text"
                              {...input}
                              placeholder="Nombre de la estación"
                            />
                            {meta.touched && meta.error && (
                              <span>{meta.error}</span>
                            )}
                          </div>
                        )}
                      </Field>
                      <div className="form-group-app">
                        <div
                          title={"Subir documento"}
                          className="cursor-pointer position-relative file-input-position-container"
                        >
                          <label>&nbsp;</label>
                          <input
                            onChange={uploadImage()}
                            type="file"
                            className="input-file-create-station"
                          />
                          <div
                            style={user.bg1}
                            className="cursor-pointer circle-folder-linea-create"
                          >
                            <FontAwesomeIcon
                              className="white margin-auto icon-file-line-create"
                              icon={faFolder}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="flex w-100">
                      <Field name="code">
                        {({ input, meta }) => (
                          <div className="form-group-app w-100">
                            <label style={user.cl2}>
                              Código de la estación
                            </label>
                            <input
                              type="text"
                              {...input}
                              placeholder="Código de la estación"
                            />
                            {meta.touched && meta.error && (
                              <span>{meta.error}</span>
                            )}
                          </div>
                        )}
                      </Field>
                      <Field name="ip_machine">
                        {({ input, meta }) => (
                          <div className="form-group-app w-100">
                            <label style={user.cl2}>Ip máquina</label>
                            <input
                              type="text"
                              {...input}
                              placeholder="IP máquina"
                            />
                            {meta.touched && meta.error && (
                              <span>{meta.error}</span>
                            )}
                          </div>
                        )}
                      </Field>
                    </div>
                    <div className="flex w-100">
                      <Field name="type">
                        {({ input, meta }) => (
                          <div className="form-group-app w-100">
                            <label style={user.cl2}>Tipo de estación</label>
                            <Select
                              styles={stylesSelect}
                              placeholder={"Tipo de estación"}
                              className="w-100 promoter-select-employe"
                              getOptionLabel={(option) => `${option.name} `}
                              getOptionValue={(option) => option.id}
                              options={STATIONS_TYPE}
                              isClearable={true}
                              isMulti={false}
                              {...input}
                            />
                            {meta.touched && meta.error && (
                              <span>{meta.error}</span>
                            )}
                          </div>
                        )}
                      </Field>
                    </div>
                    <div className="">
                      {pictures.map((image, key) => {
                        return (
                          <div key={key}>
                            <label>{shortText(image.name, 30)}</label>
                            <FontAwesomeIcon
                              title={"Eliminar"}
                              className="cursor-pointer"
                              onClick={() => removePicture(key)}
                              icon={faTimesCircle}
                            />
                          </div>
                        );
                      })}
                      {modalUbication.ubication &&
                        modalUbication.ubication.documents.map((image, key) => {
                          return (
                            <div key={key}>
                              <IconExtension document={image} />
                              &nbsp;
                              <label
                                style={user.cl2}
                                title={image.title}
                                className="cursor-pointer"
                                onClick={() =>
                                  history.push(
                                    `/app/general/document/${image.name}`
                                  )
                                }
                              >
                                {shortText(image.title, 30)}
                              </label>
                              &nbsp; &nbsp;
                              <FontAwesomeIcon
                                title={"Eliminar"}
                                className="cursor-pointer"
                                onClick={() => checkDeleteDocument(image.id)}
                                icon={faTimesCircle}
                              />
                            </div>
                          );
                        })}
                    </div>
                  </div>

                  <div className="flex justify-center">
                    <button
                      style={user.bg1}
                      className=" btn-default-create"
                      type="submit"
                    >
                      Guardar
                    </button>
                  </div>
                </form>
              )}
            />
          </div>
        </div>
      </Animated>
    </div>
  );
};

export default ModalCreate;
